export default __webpack_public_path__ + "static/media/nhsa-provincial.1264295c.png";